import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
} from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import Info from "../Info";

type IProps = {
  row: any;
  handleOpenDelete: any;
  handleEdit: any;
};

const classes = {
  between: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
  },
  category: {
    fontWeight: "bold",
  },
};

const ListItem: React.FC<IProps> = ({
  row,

  handleOpenDelete,
  handleEdit,
}) => {
  const { isRTL } = useRTL();
  const { general } = useContent();
  const { locations } = useContent().pages;

  return (
    <Card>
      <CardActionArea>
        <CardContent sx={{ pt: 1, pr: 1 }}>
          <Box sx={classes.between}>
            <Grid item xs={12} md={6}>
              <Info title={locations.lat} description={row.latitude} />
            </Grid>

            <Grid item xs={12} md={6}>
              <Info title={locations.lng} description={row.longitude} />
            </Grid>
            <CardActions disableSpacing sx={{ p: 0 }}>
              <Tooltip title={general.edit}>
                <IconButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleEdit(row.id);
                  }}
                >
                  <EditIcon color="primary" />
                </IconButton>
              </Tooltip>
              <Tooltip title={general.delete}>
                <IconButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleOpenDelete(row);
                  }}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              </Tooltip>
            </CardActions>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ListItem;
